import { render, staticRenderFns } from "./date-readonly.vue?vue&type=template&id=f770f384&"
import script from "./date-readonly.vue?vue&type=script&lang=js&"
export * from "./date-readonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDatePicker,VRow})
